<div class="container pension-savings-container">

  <div [formGroup]="dynamicForm" autocomplete="off" class="fieldHeight" *ngIf="dynamicForm">
    <div class="float-left bg-white card-background-copy">
      <div class=" row">
        <app-content-top-nav #topNavbar [visibleBackNav]='true' [enableBackNav]='!editMode'
          (onBackClickHandler)="OnBackClick()"></app-content-top-nav>
      </div>
      <div class="row">
        <div class="col-md-12 clear-all title-inner-container">
          <h1 class="custom-header-h2 responsive-text-8">
            {{contentData.yourPensionSavings.mainHeader}}
          </h1>
        </div>
      </div>
      <div class="content-container">
        <div class="row">
          <p class="content-top-subtitle">
            {{contentData.yourPensionSavings.subHeader}}
            <!-- Please tell us more about your pension savings. -->
          </p>
        </div>
        <div class="row mt-5">
          <div class="col-md-12" id="ProductDescription">
            <p class="content-top" *ngIf="quoteFundInfo && quoteFundInfo.productType">
              {{quoteFundInfo.productType.toUpperCase()=== 'C' ? contentData.yourPensionSavings.descriptionLTA :
              contentData.yourPensionSavings.descriptionGI}}
              <!-- You have previously told us about the pensions you wish to use to purchase this
              . We now need further details about each of these pensions. If you have any
              questions
              please give us a call on 0800 048 2446. -->
            </p>
          </div>
        </div>
        <div class="row mt-5" *ngIf="productcodenotUsed.length>0">
          <div class="col-md-12 clear-all content-wrapper product-code-error">
            <p aria-hidden="false" aria-live="polite" role="error" id="yourPensionSavings-productCodes-error">
              {{ productcodenotUsed.join(', ') + 'has not been associated with a fund.Please ensure each of your product  codes have been selected when adding details of your funds.'}}</p>
          </div>
        </div>

        <div 
         [ngClass]="isMaturityQuote ? 'pension-details-container border-bottom' : 'pension-details-container' "

          *ngIf="introProvider && introProvider.length > 0 && introProvider[0].fundProvider !== 'B'">
          <!-- border-bottom -->
          <div class="row">
            <div class="col-md-12 clear-all inner-title-wrapper">
              <h4 [innerHTML]="contentData.yourPensionSavings.dealPartnerHeader"></h4>
            </div>
          </div>
          <div class="row" *ngIf="introProvider && introProvider.length > 0  && !isMaturityQuote">
            <p class="row  mt-5 content-top inner">
              {{contentData.yourPensionSavings.subHeaderTFC}}
              <!--If you choose to have tax free cash, this will be paid by {{(introProvider && introProvider.length > 0) ? introProvider[0].value+'
                      ':''}} -->
            </p>
          </div>
          <div class="row">
            <p class="total-fund total-fund-container">
              <span class="label flex-50"> {{contentData.yourPensionSavings.yourPensionsTotal}}</span>
              <span class="amount margin-left-20 flex-50">
                {{resultQuote.isGMP === 'Y' || isGARProduct(resultQuote.garIndicator) || isMaturityQuote?
                formatCurrency(quoteFundInfo.totalQuoteFund)
                : totalIntroProvderFund | currency :'GBP':'symbol':'1.2-2'}}
                <!-- 50000.00 -->
              </span>
            </p>
          </div>

          <div class="row" *ngIf="!isMaturityQuote">
            <p class="total-fund margin-top-0 total-fund-container">
              <span class="label  flex-50"> {{contentData.yourPensionSavings.taxfreeTotal}}</span>
              <span class="amount margin-left-11  flex-50">
                {{resultQuote.isGMP === 'Y' || isGARProduct(resultQuote.garIndicator) ? formatTaxfree(0,'dealpartner') :
                (totalIntroProvderTaxfree | currency :'GBP')}}
                <!-- 12500.00 -->
              </span>
              <!--  [ngClass]="resultQuote.isGMP === 'Y' || isGARProduct(resultQuote.garIndicator) ? 'margin-left-21' : 'margin-left-11'" -->
            </p>
          </div>


          <!--  accordion begin -->
          <div class="row accordion-flex-container border-top margin-top-3">
            <div [ngClass]="accrdionList && accrdionList.length > 0 ? 'col-md-12 clear-all '
               : 'col-md-12 clear-all margin-top-5' ">

              <div class="accordion" role="tablist">
                <ng-container *ngFor="let pensionSavingsForm of pensionForm.controls; let i = index">
                  <div [formGroup]="pensionSavingsForm">
                    <!--  class="border-bottom" -->
                    <div class="header-row-flex-container">
                      <div *ngIf="accrdionList[i]" class="accordion-toggle pt-0"
                        [ngClass]="{'active':accrdionList[i].isActive}" id="accordion-tab-{{i+1}}" aria-selected="true"
                        aria-expanded="true" role="tab" tabindex="0"
                        (click)="accrdionList[i].isActive = !accrdionList[i].isActive">
                        <h4 class="w-75">{{accrdionList[i] && accrdionList[i].drdnpensionProvider &&
                          accrdionList[i].drdnpensionProvider.value ?
                          accrdionList[i].drdnpensionProvider.value:
                          'Not selected'}}</h4>
                        <div class="table-container" *ngIf="accrdionList[i]"
                          [ngClass]="{'hide-content':accrdionList[i].isActive}">
                          <div class="table-column col-md-12 clear-all margin-top-5">
                            <div class="table-cell  col-md-2 clear-all  flex-50">
                              <strong class="font-weight font-size-9">{{contentData.yourPensionSavings.planNumber}}
                                :</strong>
                            </div>
                            <div class="table-cell  col-md-10 clear-all flex-50">
                              <strong class="font-weight-300 margin-left-34">
                                {{accrdionList[i] && accrdionList[i].textplanNumber &&
                                accrdionList[i].textplanNumber.value
                                ?
                                (accrdionList[i].textplanNumber.value
                                | uppercase): 'Not selected'}}
                              </strong>
                            </div>
                          </div>

                          <div class=" table-column col-md-12 clear-all margin-top-5"
                            *ngIf="quoteFundInfo && quoteFundInfo.cedingProvider==='J'">
                            <div class="table-cell  col-md-2 clear-all flex-50">
                              <strong class="font-weight font-size-9">
                                Product code :</strong>
                            </div>
                            <div class="table-cell  col-md-10 clear-all flex-50">
                              <strong class="font-weight-300 margin-left-34">
                                {{accrdionList[i] && accrdionList[i].codeproductCode &&
                                accrdionList[i].codeproductCode.defaultValue ?
                                accrdionList[i].codeproductCode.defaultValue:
                                'Not selected'}}
                              </strong>
                            </div>
                          </div>

                          <div class="table-column col-md-12 clear-all">
                            <div class="table-cell col-md-6 clear-all flex-50"
                              *ngIf="quoteFundInfo && quoteFundInfo.productType">
                              <strong class="font-weight font-size-9">
                                {{contentData.yourPensionSavings.fundTotal}}
                                <!-- {{quoteFundInfo.productType.toUpperCase() === 'C' ? 'annuity' : 'plan'}} -->
                                :
                              </strong>
                            </div>
                            <div class="table-cell col-md-6 clear-all flex-50"
                              [ngClass]="{'margin-top-20':!isGARProduct(resultQuote.garIndicator)}">
                              <strong class="font-weight-300 mar-left-5">
                                {{isGARProduct(resultQuote.garIndicator) || resultQuote.isGMP === 'Y' || isMaturityQuote?
                                formatCurrency(quoteFundInfo.totalQuoteFund) : (accrdionList[i] &&
                                accrdionList[i].cncyfundValue
                                && accrdionList[i].cncyfundValue.value ?
                                formatCurrency(accrdionList[i].cncyfundValue.value):
                                '£0.00')}}
                              </strong>
                            </div>
                            <div class="col-md-2 clear-all"></div>
                          </div>

                          <div class="table-column col-md-12 clear-all" *ngIf="!isMaturityQuote">
                            <div class="table-cell col-md-6 clear-all flex-50">
                              <strong class="font-weight font-size-9">{{contentData.yourPensionSavings.taxfreeTotal}}
                                :</strong>
                            </div>
                            <div class="table-cell col-md-6 clear-all flex-50">
                              <strong class="font-weight-300  mar-left-5"
                                *ngIf="resultQuote.isGMP !== 'Y' && !isGARProduct(resultQuote.garIndicator) && !isMaturityQuote">
                                {{accrdionList[i] ? formatTaxfree(i): '0.00'}}
                              </strong>
                              <strong class="font-weight-300  mar-left-5"
                                *ngIf="resultQuote.isGMP === 'Y' || isGARProduct(resultQuote.garIndicator)  || isMaturityQuote">
                                {{formatTaxfree(0,'dealpartner')}}
                              </strong>
                            </div>
                            <div class="col-md-2 clear-all"></div>
                          </div>
                        </div>
                      </div>
                      <span *ngIf="pensionForm.controls.length > 1 && accrdionList[i] && !accrdionList[i].isActive"
                        class="icon icon-bin delete-icon"
                        [ngClass]="{'active':accrdionList[i].isActive,'delete-icon-productcode':quoteFundInfo.cedingProvider==='J'}"
                        (click)="triggerWADelete('',accrdionList[i]); pensionForm.removeAt(i);accrdionList.splice(i, 1);
                        calculateTotalFund();calculateTaxfreeTotal();">
                      </span>
                    </div>
                    <div *ngIf="accrdionList[i]" id="accordion-tab-{{i+1}}-content" class="accordion-content clear-all"
                      [ngClass]="{'active':accrdionList[i].isActive ,'border-bottom-none': isMaturityQuote}" aria-hidden="false" role="tabpanel">
                      <div class="col-md-12 clear-all padding-30" *ngIf="!isMaturityQuote">
                        <!-- <div class="col-md-12 field clear-all">
                              <span>
                                Pension provider
                              </span>
                            </div> -->
                        <div class="col-md-5 value clear-all width-45">
                          <!-- <app-text-input *ngIf="accrdionList && accrdionList.length>0" [pageName]="'yourPensionSavings'" [controllerData]="accrdionList[i].textpensionProvider"
                                [parent]="pensionSavingsForm" [controlName]="'textpensionProvider'" formControlName="textpensionProvider"></app-text-input> -->
                          <app-dropdown *ngIf="accrdionList && accrdionList.length>0" [pageName]="'yourPensionSavings'"
                            (onChangeHandler)="ddlChange($event,i)"
                            [dropdownConfig]="accrdionList[i].drdnpensionProvider" [controlName]="'drdnpensionProvider'"
                            [parent]="pensionSavingsForm">
                          </app-dropdown>
                          <!-- <app-pension-provider-search *ngIf="accrdionList && accrdionList.length>0" [pageName]="'yourPensionSavings'" [parent]="pensionSavingsForm" [controlName]="'textpensionProvider'"
                                [controllerData]="accrdionList[i].textpensionProvider" (onSelectedProvider)=onSelectedProvider($event,i)></app-pension-provider-search> -->
                        </div>
                        <div class="col-md-7 value clear-all"></div>
                      </div>
                      <div class="col-md-12 clear-all" 
                       [ngClass]="{'col-md-12 clear-all pad-top-30 padding-bottom-30': isMaturityQuote, 
                       'col-md-12 clear-all': (!accrdionList[i].addressSeachEnabled && !isMaturityQuote )}"
                      >
                      <!-- [ngClass]="(isMaturityQuote || !accrdionList[i].addressSeachEnabled) ? 'col-md-12 clear-all': 'col-md-12 clear-all padding-bottom-30' " -->
                        <div class="col-md-12 field clear-all">
                          <span>
                            Plan number
                          </span>
                        </div>
                        <div class="col-md-5 value clear-all width-45">
                          <app-text-input *ngIf="accrdionList && accrdionList.length>0"
                            [pageName]="'yourPensionSavings'" [controllerData]="accrdionList[i].textplanNumber"
                            [parent]="pensionSavingsForm" [controlName]="'textplanNumber'"
                            formControlName="textplanNumber"
                            (textChangeEventEmitter)="policyNoEventEmitter($event,i)"></app-text-input>
                        </div>
                        <div class="col-md-7 value clear-all"></div>
                      </div>

                      <div *ngIf="quoteFundInfo && quoteFundInfo.cedingProvider==='J'"
                        class="col-md-12 clear-all padding-bot-top-30 ">
                        <div class="col-md-12 mar-t-30 bg-lightblue" style="margin-bottom: 10px">
                          <p class="inner-content-data" id="productcodeDescription">
                            {{accrdionList[i].codeproductCode['description']}}
                          </p>
                        </div>
                        <div class="col-md-5 value clear-all width-45">
                          <!-- <app-text-input *ngIf="accrdionList && accrdionList.length>0" [pageName]="'yourPensionSavings'" [controllerData]="accrdionList[i].textpensionProvider"
                                [parent]="pensionSavingsForm" [controlName]="'textpensionProvider'" formControlName="textpensionProvider"></app-text-input> -->
                          <app-dropdown [ddDisabled]="selectedProductCode" *ngIf="accrdionList && accrdionList.length>0 && !isMaturityQuote"
                            [pageName]="'yourPensionSavings'" (onChangeHandler)="ddlChangeProductCode($event,i)"
                            [dropdownConfig]="accrdionList[i].codeproductCode" [controlName]="'codeproductCode'"
                            [parent]="pensionSavingsForm">
                          </app-dropdown>
                          <!-- <app-pension-provider-search *ngIf="accrdionList && accrdionList.length>0" [pageName]="'yourPensionSavings'" [parent]="pensionSavingsForm" [controlName]="'textpensionProvider'"
                                [controllerData]="accrdionList[i].textpensionProvider" (onSelectedProvider)=onSelectedProvider($event,i)></app-pension-provider-search> -->
                        </div>
                        <div class="col-md-7 value clear-all"></div>
                      </div>

                      <div class="col-md-12 clear-all padding-bottom-30" *ngIf="!isMaturityQuote">
                        <div class="col-md-5 value clear-all width-45" *ngIf="!accrdionList[i].addressSeachEnabled">

                          <div class="col-md-12 clear-all margin-top-30">
                            <app-addressLines [pageName]="'yourPensionSavings'"
                              [controllerData]="accrdionList[i].adrsaddressline1" [parent]="pensionSavingsForm"
                              [controlName]="'adrsaddressline1'">
                            </app-addressLines>
                          </div>
                          <div class="col-md-12 clear-all margin-top-30">
                            <app-addressLines [pageName]="'yourPensionSavings'"
                              [controllerData]="accrdionList[i].adrsaddressline2" [parent]="pensionSavingsForm"
                              [controlName]="'adrsaddressline2'">
                            </app-addressLines>
                          </div>
                          <div class="col-md-12 clear-all margin-top-30">
                            <app-addressLines [pageName]="'yourPensionSavings'"
                              [controllerData]="accrdionList[i].adrsaddressline3" [parent]="pensionSavingsForm"
                              [controlName]="'adrsaddressline3'">
                            </app-addressLines>
                          </div>
                          <div class="col-md-12 clear-all margin-top-30">
                            <app-addressLines [pageName]="'yourPensionSavings'"
                              [controllerData]="accrdionList[i].adrsaddressline4" [parent]="pensionSavingsForm"
                              [controlName]="'adrsaddressline4'">
                            </app-addressLines>
                          </div>
                          <div class="col-md-12 clear-all margin-top-30" *ngIf="!overseasCustomer">
                            <app-postcode [postCodeConfig]="accrdionList[i].postcode" [controlName]="'postcode'"
                              formControlName="postcode" [parent]="pensionSavingsForm" [required]="'true'">
                            </app-postcode>
                          </div>
                          <div class="margin-top-10 float-left" *ngIf="!overseasCustomer">
                            <p class="font-weight-300 font-size subtitle clear-all" id="address-manual-p">
                              <strong>
                                <a id="address-manual" (click)="onAddressSeachClick(i)" class="clickHere mr-7">
                                  {{contentData.yourPensionSavings.anotherAddress}} </a>
                              </strong>
                            </p>
                          </div>
                        </div>
                        <div class="col-md-5 value clear-all width-45 pad-top-30 margin-bottom-30"
                          *ngIf="accrdionList[i].addressSeachEnabled">
                          <div class="col-md-12 clear-all">
                            <!-- {{333333}}
                            {{accrdionList[i].addressSeachEnabled}} -->
                            <app-address-search [pageName]="'yourPensionSavings'" [parent]="pensionSavingsForm"
                              (onSelecteAddress)=onSelecteAddress($event,i)></app-address-search>
                          </div>
                          <div>
                            <p class="font-weight-300 font-size subtitle clear-all" id="address-qas-p">
                              <strong>
                                <a id="address-qas" (click)="onManualClick(i)" class="clickHere mr-7">
                                  {{contentData.yourPensionSavings.addManually}} </a>
                              </strong>
                            </p>
                          </div>
                        </div>
                        <div class="col-md-7 value clear-all"></div>
                      </div>
                      <div  class="col-md-12 clear-all" 
                      [ngClass]="isMaturityQuote ? 'col-md-12 clear-all pad-top-30 padding-bottom-30' : 'col-md-12 clear-all padding-bot-top-30' "
                      >
                        <!--  padding-top-30 -->
                        <div *ngIf="quoteFundInfo && quoteFundInfo.productType" class="col-md-5 clear-all width-45">
                          <label class="form-label" id="fundTotal" >
                            <!-- [ngClass]="{'text-wrap': isMaturityQuote}" -->                             
                            {{contentData.yourPensionSavings.fundTotal}}
                          </label>
                          <span class="newAmount margin-left-11"
                            *ngIf="isGARProduct(resultQuote.garIndicator) || resultQuote.isGMP === 'Y'  || isMaturityQuote">{{formatCurrency(quoteFundInfo.totalQuoteFund)}}</span>
                          <app-currency
                            *ngIf="accrdionList && accrdionList.length>0 && resultQuote.isGMP !== 'Y' && !isGARProduct(resultQuote.garIndicator) && !isMaturityQuote"
                            [parent]="pensionSavingsForm" [controllerData]="accrdionList[i].cncyfundValue"
                            [controlName]="'cncyfundValue'" [componentName]="'yourPensionSavings'"
                            (currencyChangeEventEmitter)="currencyChangeHandler($event, i)"></app-currency>
                        </div>
                        <div class="col-md-2 width-10"></div>
                        <div class="questions-container col-md-5 clear-all width-45"
                          *ngIf="!responseApplicationData.deathInService  && !isMaturityQuote ">
                          <ng-container
                            *ngIf="resultQuote.isGMP !== 'Y' && !isGARProduct(resultQuote.garIndicator);else tfcGMP">
                            <div class="col-md-12 clear-all">
                              <app-question *ngIf="accrdionList && accrdionList.length>0"
                                [childId]="'rbtntaxfreeToggle'" (valueChange)='toggleSlider($event,i)'
                                [questionConfig]="accrdionList[i].rbtntaxfreeToggle" [parent]="pensionSavingsForm"
                                (onDisplayMobileTooltipEmitter)="displayTooltipMessage('rbtntaxfreeToggle')"
                                [controlName]="'rbtntaxfreeToggle'">
                              </app-question>
                            </div>
                            <div *ngIf="showWarningDealPartner && i==0" class="question-info col-md-12">
                              <p>{{warningTextDealPartner}}</p>
                            </div>

                            <div
                              *ngIf="accrdionList && accrdionList.length>0 && accrdionList[i].sldrtaxfreeSlider && accrdionList[i].sldrtaxfreeSlider.visible"
                              class="col-md-12 clear-all mb-2">
                              <app-percentage-currency
                                *ngIf="responseApplicationData.ptfc && accrdionList && accrdionList.length>0"
                                [parent]="pensionSavingsForm" [controllerData]="accrdionList[i].sldrtaxfreeSlider"
                                [controlName]="'sldrtaxfreeSlider'" [componentName]="'yourPesionSavings'"
                                (percentagecurrencyChangeEventEmitter)="PercentagetaxfreeChangeHandler($event, i)"></app-percentage-currency>
                              <app-simple-slider
                                *ngIf="!responseApplicationData.ptfc && accrdionList && accrdionList.length>0"
                                [sliderId]="'sldrtaxfreeSlider'" [sliderConfig]="accrdionList[i].sldrtaxfreeSlider"
                                [parent]="pensionSavingsForm" [controlName]="'sldrtaxfreeSlider'"
                                (onScrollEndHandler)="changeScrollParams($event, i)"></app-simple-slider>

                            </div>
                            <div
                              *ngIf="accrdionList && accrdionList.length>0 && accrdionList[i].cncyfundValueTaxfree && accrdionList[i].cncyfundValueTaxfree.visible"
                              class="col-md-12 clear-all mb-2">
                              <app-currency *ngIf="accrdionList && accrdionList.length>0" [parent]="pensionSavingsForm"
                                [controllerData]="accrdionList[i].cncyfundValueTaxfree"
                                [controlName]="'cncyfundValueTaxfree'" [componentName]="'yourPesionSavings'"
                                (currencyChangeEventEmitter)="taxfreeChangeHandler($event, i)"></app-currency>
                            </div>
                          </ng-container>
                          <ng-template #tfcGMP>
                            <div style="float:left;display: flex;width:100%">
                              <label class="form-label" id="tfc">
                                {{contentData.yourPensionSavings.taxfreeTotal}}
                              </label>
                              <app-tool-tip-notification [childId]="'rbtntaxfreeToggle'"
                                [tooltipData]="userInputDetail.radioButtontaxfreeCashConfig.infoIconData"
                                (onDisplayMobileTooltipEmitter)="displayTooltipMessage('rbtntaxfreeToggle')">
                              </app-tool-tip-notification>
                            </div>
                            <span class="newAmount margin-left-11"
                              *ngIf="resultQuote.isGMP === 'Y' || isGARProduct(resultQuote.garIndicator)">{{formatTaxfree(0,
                              'dealpartner')}}</span>
                          </ng-template>
                        </div>
                      </div>
                      <div class="col-md-12 clear-all padding-bottom-30">
                        <!--  border-bottom -->
                        <div role="button" class="col-md-5 clear-all width-45">
                          <div class="mt--10">
                            <app-question *ngIf="accrdionList && accrdionList.length>0" [questiontextRequired]="true"
                              [childId]="'rbtnfundtransfertype'" [questionConfig]="accrdionList[i].rbtnfundtransfertype"
                              [parent]="pensionSavingsForm" [controlName]="'rbtnfundtransfertype'"
                              (toggleChange)="toggleContainer($event)"
                              [disable]="resultQuote.isGMP === 'Y' || isGARProduct(resultQuote.garIndicator) ? true : false">
                            </app-question>
                          </div>
                        </div>
                        <div class="col-md-2 width-10"></div>
                        <div role="button" class="col-md-5 clear-all width-45"
                          *ngIf="resultQuote.isGMP !=='Y' && !isGARProduct(resultQuote.garIndicator) && !isMaturityQuote">
                          <div class="mt-10">
                            <app-question *ngIf="accrdionList && accrdionList.length>0" [questiontextRequired]="true"
                              [childId]="'rbtnfunddrawdown'" [questionConfig]="accrdionList[i].rbtnfunddrawdown"
                              [parent]="pensionSavingsForm" [controlName]="'rbtnfunddrawdown'"
                              (onDisplayMobileTooltipEmitter)="displayTooltipMessage('rbtnfunddrawdown')"
                              (toggleChange)="toggleContainer($event)" [id]="'rbtnfunddrawdown'">
                            </app-question>
                          </div>
                        </div>
                        <div class="col-md-12 clear-all" *ngIf="pensionForm.value[i].rbtnfundtransfertype ==='P'">
                          <div class="col-md-12 mar-t-30 bg-lightblue">
                            <p class="inner-content-data" id="warningmessageforSegment{{i}}">
                              {{contentData.yourPensionSavings.DrawdownWarningMessage}}
                            </p>
                          </div>
                        </div>
                      </div>


                    </div>

                  </div>
                </ng-container>
              </div>
            </div>

            <div 
            [ngClass]="isMaturityQuote ? 'row add-pension-container' : 'row add-pension-container border-top ' "
              *ngIf="resultQuote.isGMP !=='Y' && !isGARProduct(resultQuote.garIndicator) && !isMaturityQuote">
              <!-- border-top -->
              <button class="btn btn-primary margin-0" type="button" (click)="onSave()">
                <span *ngIf="accrdionList.length == 0 else showElse">Add a pension</span>
                <ng-template #showElse>
                    {{contentData.yourPensionSavings.addPensionCTA}}                  
                </ng-template>
              </button>
            </div>

            <div class="form-validation-error no-provider"
              *ngIf="noPensionAdded && resultQuote.isGMP !=='Y' && !isGARProduct(resultQuote.garIndicator) && !isMaturityQuote">
              <i class="icon icon-error" aria-hidden="true"></i>
              <p aria-hidden="false" role="error" aria-live="polite">At least one Pension Provider must be entered</p>
            </div>
          </div>
          <!-- accordion ends -->
        </div>
        <!-- <div
          *ngIf="quoteFundInfo && quoteFundInfo.cedingProvider && resultQuote.isGMP !=='Y' && !isGARProduct(resultQuote.garIndicator) && !isMaturityQuote"
          class="col-md-12 underline">
           margin-top-30
        </div> -->

        <div class="col-md-12 clear-all border-bottom" *ngIf="!accrdionList"></div>

        <div *ngIf="externalCheck()" class="col-md-12 clear-all inner-content-wrapper border-bottom">
          <div class="col-md-12 clear-all inner-title-wrapper">
            <h4 class="title-text-2">
              {{quoteFundInfo.cedingProvider === null ? contentData.yourPensionSavings.headerExternal :
              contentData.yourPensionSavings.mainHeaderExternal}}
            </h4>
          </div>
          <div class="col-md-12 clear-all content-wrapper-2">
            <p class="content-top inner">
              {{contentData.yourPensionSavings.subHeaderExternal}}
            </p>
          </div>
          <div class="col-md-12 clear-all">
            <p class="total-fund total-fund-container">
              <span class="label  flex-50">{{contentData.yourPensionSavings.yourPensionsTotal}}</span>
              <span class="amount margin-left-20  flex-50">{{totalExtIntroProvderFund | currency:'GBP'}}</span>
            </p>
          </div>
          <div class="col-md-12 clear-all">
            <p class="total-fund margin-top-0 total-fund-container">
              <span class="label flex-50"> {{contentData.yourPensionSavings.taxfreeTotal}}</span>
              <span class="amount margin-left-11 flex-50">{{totalExtIntroProvderTaxfree | currency:'GBP'}}</span>
            </p>
          </div>
          <div class="accordion-flex-container border-top margin-top-3">
            <div class="col-md-12 clear-all " *ngIf="accrdionListExt && accrdionListExt.length > 0">
              <!-- border-bottom -->
              <div class="accordion" role="tablist">
                <ng-container *ngFor="let pensionSavingsForm of extPensionForm.controls; let i = index">
                  <div [formGroup]="pensionSavingsForm">
                    <!--  class="border-bottom" -->
                    <div class="header-row-flex-container">
                      <div *ngIf="accrdionListExt[i]" class="accordion-toggle"
                        [ngClass]="{'active':accrdionListExt[i].isActive}" id="accordion-tab-{{i+1}}"
                        aria-selected="true" aria-expanded="true" role="tab" tabindex="0"
                        (click)="accrdionListExt[i].isActive = !accrdionListExt[i].isActive">
                        <h4 class="w-75">{{accrdionListExt[i] && accrdionListExt[i].textpensionProvider &&
                          accrdionListExt[i].textpensionProvider.value ? accrdionListExt[i].textpensionProvider.value:
                          'Not selected'}}</h4>
                        <div class="table-container" *ngIf="accrdionListExt[i]"
                          [ngClass]="{'hide-content':accrdionListExt[i].isActive}">
                          <div class="table-column col-md-12 clear-all margin-top-5">
                            <div class="table-cell col-md-2 clear-all  flex-50">
                              <strong class="font-weight font-size-9">{{contentData.yourPensionSavings.planNumber}}
                                :</strong>
                            </div>
                            <div class="table-cell  col-md-10 clear-all flex-50">
                              <strong class="font-weight-300 margin-left-34">
                                {{accrdionListExt[i] && accrdionListExt[i].textplanNumber &&
                                accrdionListExt[i].textplanNumber.value ? accrdionListExt[i].textplanNumber.value:
                                'Not selected'}}
                              </strong>
                            </div>
                          </div>
                          <div class="table-column col-md-12 clear-all">
                            <div class="table-cell  col-md-6 clear-all flex-50">
                              <strong class="font-weight font-size-9">{{contentData.yourPensionSavings.fundTotal}}
                                <!-- {{quoteFundInfo.productType.toUpperCase() === 'C' ? 'annuity' : 'plan'}} -->
                                :
                              </strong>
                            </div>
                            <div class="table-cell  col-md-6 clear-all flex-50">
                              <strong class="font-weight-300 mar-left-5">
                                {{accrdionListExt[i] && accrdionListExt[i].cncyfundValue &&
                                accrdionListExt[i].cncyfundValue.value ?
                                formatCurrency(accrdionListExt[i].cncyfundValue.value):
                                '£0.00'}}
                              </strong>
                            </div>
                            <div class="col-md-2 clear-all"></div>
                          </div>
                          <div class="table-column col-md-12 clear-all">
                            <div class="table-cell  col-md-6 clear-all flex-50">
                              <strong class="font-weight font-size-9">{{contentData.yourPensionSavings.taxfreeTotal}}
                                :</strong>
                            </div>
                            <div class="table-cell  col-md-6 clear-all flex-50">
                              <strong class="font-weight-300 mar-left-5">{{accrdionListExt[i] ? formatTaxfree(i,'ext'):
                                '0.00'}}</strong>
                            </div>
                            <div class="col-md-2 clear-all"></div>
                          </div>
                        </div>
                      </div>
                      <span *ngIf="extPensionForm.controls.length > 1 && accrdionListExt[i]"
                        class="icon icon-bin delete-icon" [ngClass]="{'active':accrdionListExt[i].isActive}" (click)="triggerWADelete('ext',accrdionListExt[i]); extPensionForm.removeAt(i);accrdionListExt.splice(i, 1);
                        calculateTotalFund('ext');calculateTaxfreeTotal('ext');">
                      </span>
                    </div>



                    <div *ngIf="accrdionListExt[i]" id="accordion-tab-{{i+1}}-content"
                      class="accordion-content clear-all" [ngClass]="{'active':accrdionListExt[i].isActive}"
                      aria-hidden="false" role="tabpanel">
                      <div class="col-md-12 clear-all padding-30">
                        <!-- <div class="col-md-12 field clear-all">
                        <span>
                          Pension provider
                        </span>
                      </div> -->
                        <div class="col-md-5 value clear-all width-45">
                          <!-- <app-text-input *ngIf="accrdionListExt && accrdionListExt.length>0" [pageName]="'yourPensionSavings'" [controllerData]="accrdionListExt[i].textpensionProvider"
                          [parent]="pensionSavingsForm" [controlName]="'textpensionProvider'" formControlName="textpensionProvider"></app-text-input>
                         -->
                          <app-pension-provider-search *ngIf="quoteFundInfo" [pageName]="'yourPensionSavings'"
                            [parent]="pensionSavingsForm" [controlName]="'textpensionProvider'"
                            [controllerData]="accrdionListExt[i].textpensionProvider"
                            [introProvider]="quoteFundInfo.cedingProvider"
                            (onSelectedProvider)="onSelectedProvider($event,i,'ext')"></app-pension-provider-search>
                        </div>
                        <div class="col-md-7 value clear-all"></div>
                      </div>
                      <div class="col-md-12 clear-all" [ngClass]="!accrdionListExt[i].addressSeachEnabled ? 
                        'col-md-12 clear-all padding-bottom-30': 'col-md-12 clear-all' ">
                        <!-- padding-bottom-30 -->
                        <div class="col-md-12 field clear-all">
                          <span>
                            Plan number
                          </span>
                        </div>
                        <div class="col-md-5 value clear-all width-45">
                          <app-text-input *ngIf="accrdionListExt && accrdionListExt.length>0"
                            [pageName]="'yourPensionSavings'" [controllerData]="accrdionListExt[i].textplanNumber"
                            [parent]="pensionSavingsForm" [controlName]="'textplanNumber'"
                            formControlName="textplanNumber"
                            (textChangeEventEmitter)="policyNoEventEmitter($event,i,'ext')"></app-text-input>
                        </div>
                        <div class="col-md-7 value clear-all"></div>
                      </div>
                      <div class="col-md-12 clear-all padding-bottom-30">
                        <div class="col-md-5 value clear-all width-45 " *ngIf="!accrdionListExt[i].addressSeachEnabled">
                          <div class="col-md-12 clear-all">
                            <app-addressLines [pageName]="'yourPensionSavings'"
                              [controllerData]="accrdionListExt[i].adrsaddressline1" [parent]="pensionSavingsForm"
                              [controlName]="'adrsaddressline1'">
                            </app-addressLines>
                          </div>
                          <div class="col-md-12 clear-all margin-top-30">
                            <app-addressLines [pageName]="'yourPensionSavings'"
                              [controllerData]="accrdionListExt[i].adrsaddressline2" [parent]="pensionSavingsForm"
                              [controlName]="'adrsaddressline2'">
                            </app-addressLines>
                          </div>
                          <div class="col-md-12 clear-all margin-top-30">
                            <app-addressLines [pageName]="'yourPensionSavings'"
                              [controllerData]="accrdionListExt[i].adrsaddressline3" [parent]="pensionSavingsForm"
                              [controlName]="'adrsaddressline3'">
                            </app-addressLines>
                          </div>
                          <div class="col-md-12 clear-all margin-top-30">
                            <app-addressLines [pageName]="'yourPensionSavings'"
                              [controllerData]="accrdionListExt[i].adrsaddressline4" [parent]="pensionSavingsForm"
                              [controlName]="'adrsaddressline4'">
                            </app-addressLines>
                          </div>
                          <div class="col-md-12 clear-all margin-top-30" *ngIf="!overseasCustomer">
                            <app-postcode [postCodeConfig]="accrdionListExt[i].postcode" [controlName]="'postcode'"
                              formControlName="postcode" [parent]="pensionSavingsForm" [required]="'true'">
                            </app-postcode>
                          </div>
                          <div class="margin-top-10 float-left" *ngIf="!overseasCustomer">
                            <p class="font-weight-300 font-size subtitle clear-all" id="address-manual-p">
                              <strong>
                                <a id="address-manual" (click)="onAddressSeachClick(i,'ext')" class="clickHere mr-7">
                                  {{contentData.yourPensionSavings.anotherAddress}} </a>
                              </strong>
                            </p>
                          </div>
                        </div>
                        <div class="col-md-5 value clear-all width-45 pad-top-30 margin-bottom-30"
                          *ngIf="accrdionListExt[i].addressSeachEnabled">
                          <div class="col-md-12 clear-all">
                            <app-address-search [pageName]="'yourPensionSavings'" [parent]="pensionSavingsForm"
                              (onSelecteAddress)="onSelecteAddress($event,i,'ext')"></app-address-search>
                          </div>
                          <div>
                            <p class="font-weight-300 font-size subtitle clear-all" id="address-qas-p">
                              <strong>
                                <a id="address-qas" (click)="onManualClick(i,'ext')" class="clickHere mr-7">
                                  {{contentData.yourPensionSavings.addManually}} </a>
                              </strong>
                            </p>
                          </div>
                        </div>
                        <div class="col-md-7 value clear-all"></div>
                      </div>
                      <div class="col-md-12 clear-all padding-bot-top-30">
                        <div *ngIf="quoteFundInfo && quoteFundInfo.productType" class="col-md-5 clear-all width-45">
                          <label class="form-label" id="email">
                            {{contentData.yourPensionSavings.fundTotal + ' '}}
                            <!-- {{quoteFundInfo.productType.toUpperCase() === 'C' ? 'annuity' : 'plan'}} -->
                          </label>
                          <app-currency *ngIf="accrdionListExt && accrdionListExt.length>0"
                            [parent]="pensionSavingsForm" [controllerData]="accrdionListExt[i].cncyfundValue"
                            [controlName]="'cncyfundValue'" [componentName]="'yourPensionSavings'"
                            (currencyChangeEventEmitter)="currencyChangeHandler($event, i, 'ext')"></app-currency>
                        </div>
                        <div class="col-md-2 width-10"></div>
                        <div class="questions-container col-md-5 clear-all width-45"
                          *ngIf="!responseApplicationData.deathInService">
                          <div class="col-md-12 clear-all">
                            <app-question *ngIf="accrdionListExt && accrdionListExt.length>0"
                              [childId]="'rbtntaxfreeToggle'" (valueChange)="toggleSlider($event,i,'ext')"
                              [questionConfig]="accrdionListExt[i].rbtntaxfreeToggle" [parent]="pensionSavingsForm"
                              (onDisplayMobileTooltipEmitter)="displayTooltipMessage('rbtntaxfreeToggle')"
                              [controlName]="'rbtntaxfreeToggle'">
                            </app-question>
                          </div>
                          <div *ngIf="showWarningExternal && i==0" class="question-info col-md-12">
                            <p>{{warningTextExternal}}</p>
                          </div>

                          <div
                            *ngIf="accrdionListExt && accrdionListExt.length>0 && accrdionListExt[i].sldrtaxfreeSlider && accrdionListExt[i].sldrtaxfreeSlider.visible"
                            class="col-md-12 clear-all mb-2">
                            <app-percentage-currency
                              *ngIf="responseApplicationData.ptfc && accrdionListExt && accrdionListExt.length>0"
                              [parent]="pensionSavingsForm" [controllerData]="accrdionListExt[i].sldrtaxfreeSlider"
                              [controlName]="'sldrtaxfreeSlider'" [componentName]="'yourPesionSavings'"
                              (percentagecurrencyChangeEventEmitter)="PercentagetaxfreeChangeHandler($event, i,'ext')"></app-percentage-currency>
                            <app-simple-slider
                              *ngIf="!responseApplicationData.ptfc && accrdionListExt && accrdionListExt.length>0"
                              [sliderId]="'sldrtaxfreeSlider'" [sliderConfig]="accrdionListExt[i].sldrtaxfreeSlider"
                              [parent]="pensionSavingsForm" [controlName]="'sldrtaxfreeSlider'"
                              (onScrollEndHandler)="changeScrollParams($event, i,'ext')"></app-simple-slider>
                          </div>
                          <div
                            *ngIf="accrdionListExt && accrdionListExt.length>0 && accrdionListExt[i].cncyfundValueTaxfree && accrdionListExt[i].cncyfundValueTaxfree.visible"
                            class="col-md-12 clear-all mb-2">
                            <app-currency *ngIf="accrdionListExt && accrdionListExt.length>0"
                              [parent]="pensionSavingsForm" [controllerData]="accrdionListExt[i].cncyfundValueTaxfree"
                              [controlName]="'cncyfundValueTaxfree'" [componentName]="'yourPesionSavings'"
                              (currencyChangeEventEmitter)="taxfreeChangeHandler($event, i,'ext')"></app-currency>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-12 clear-all padding-bottom-30">
                        <div role="button" class="col-md-5 clear-all width-45">
                          <div class="mt--10">
                            <app-question *ngIf="accrdionListExt && accrdionListExt.length>0"
                              [questiontextRequired]="true" [childId]="'rbtnfundtransfertype'"
                              [questionConfig]="accrdionListExt[i].rbtnfundtransfertype" [parent]="pensionSavingsForm"
                              [controlName]="'rbtnfundtransfertype'" (toggleChange)="toggleContainer($event)">
                            </app-question>
                          </div>
                        </div>
                        <div class="col-md-2 width-10"></div>
                        <div role="button" class="col-md-5 clear-all width-45">
                          <div class="mt-10">
                            <app-question *ngIf="accrdionListExt && accrdionListExt.length>0"
                              [questiontextRequired]="true" [childId]="'rbtnfunddrawdown'"
                              [questionConfig]="accrdionListExt[i].rbtnfunddrawdown" [parent]="pensionSavingsForm"
                              [controlName]="'rbtnfunddrawdown'" (toggleChange)="toggleContainer($event)"
                              (onDisplayMobileTooltipEmitter)="displayTooltipMessage('rbtnfunddrawdown')"
                              [id]="'rbtnfunddrawdown'">
                            </app-question>
                          </div>
                        </div>
                        <div class="col-md-12 clear-all " *ngIf="extPensionForm.value[i].rbtnfundtransfertype ==='P'">
                          <div class="col-md-12 mar-t-30 bg-lightblue">
                            <p class="inner-content-data" id="warningmessageforSegmentExt{{i}}">
                              {{contentData.yourPensionSavings.DrawdownWarningMessage}}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </ng-container>
              </div>
            </div>
            <div   [ngClass]="isMaturityQuote ? 'row add-pension-container' : 'row add-pension-container border-top ' ">
              <!-- border-top -->
              <button class="btn btn-primary margin-0" type="button" (click)="onSave('ext')">
                <span *ngIf="accrdionListExt.length == 0 else showElseIf">Add a pension</span>
                <ng-template #showElseIf>                 
                    {{contentData.yourPensionSavings.addPensionCTA}}
                </ng-template></button>
            </div>
            <div *ngIf="noExtPensionAdded" class="form-validation-error no-provider">
              <i class="icon icon-error" aria-hidden="true"></i>
              <p aria-hidden="false" role="error" aria-live="polite">At least one Pension Provider must be entered</p>
            </div>
          </div>
        </div>
        <!-- <div
          *ngIf="quoteFundInfo && (quoteFundInfo.externalFundProvided === 'Y' || isDealPartnerWithoutProductCode) && resultQuote.isGMP !=='Y' && !isGARProduct(resultQuote.garIndicator)"
          class="col-md-12 underline">
        </div> -->
       



      </div>
      <div class="col-md-12 clear-all bottom-container">
        <div class="float-left">
          <app-save [location]="'contentBottom'"></app-save>
        </div>
        <div class="float-right">
          <app-content-bottom-nav (onNextHandler)="gotoNext()" [userInputDetail]="ButtonConfig"
            [buttonType]="'normalCTA'"></app-content-bottom-nav>
          <!-- <app-content-bottom-nav [userInputDetail]="userInputDetail" (click)="gotoPensionDetails()" [buttonType]="'normalCTA'"></app-content-bottom-nav> -->
        </div>
      </div>
    </div>
  </div>
  <!-- <app-modal *ngIf="displayTooltipAlert" [modalConfig]="userInputDetail.radioButtontaxfreeCashConfig"
    (closeModal)="closeTooltipModal()" (primaryBtnClick)="alertTooltipPrimaryBtnClick($event)"
    (secondaryBtnClick)="alertSecondaryBtnClick()" [tooltipFlag]="true"></app-modal> -->

  <app-modal *ngIf="displayTooltipAlert" [modalConfig]="tooltipModalConfig" (closeModal)="closeModal()"
    (primaryBtnClick)="alertTooltipPrimaryBtnClick($event)" (secondaryBtnClick)="alertSecondaryBtnClick()"
    [tooltipFlag]="true"></app-modal>
</div>